import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "D:\\фильмы\\cuckoo_car_final\\cuckoo_car\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\фильмы\\cuckoo_car_final\\cuckoo_car\\src\\app\\online-booking\\components\\BookingForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\фильмы\\cuckoo_car_final\\cuckoo_car\\src\\components\\common\\Header.tsx");
;
import(/* webpackMode: "eager" */ "D:\\фильмы\\cuckoo_car_final\\cuckoo_car\\src\\components\\ui\\AppIcon.tsx");
